/* AO - vehicle picker on the brand landing pages (sections/ao-vehicle-picker.liquid).
 *
 * Steps between model -> generation -> "Shopping for" bar, and filters the
 * product grid below IN PLACE once a generation is picked.
 *
 * HOW THE GRID IS FILTERED. Not with a filter parameter: tag filtering is not
 * switched on in Search & Discovery (checked 2026-10-07 - `filter.p.tag` is
 * silently ignored), and a generation spans several year tags anyway. Instead
 * the grid is swapped for the generation COLLECTION's own grid, fetched with
 * the Section Rendering API through this page's own template:
 *
 *     /collections/model-y-2026-refresh?view=tesla&section_id=template--...__main
 *
 * `view` makes Shopify render that collection with this page's template, and
 * the section id is this page's grid, so the swapped grid keeps this page's
 * settings. (The first version passed the section FILE name, which renders
 * with schema defaults - and those switch the filter sidebar on.) Checked on
 * live 2026-10-07: 92 products for New Model Y, 7 with
 * &filter.p.product_type=Lighting. The category tiles add that same
 * product_type filter, which IS enabled.
 *
 * 🔴 THE SECTION IS REPLACED WHOLE, NOT ITS innerHTML. Its <style> block is
 * scoped to its own id (#shopify-section-abstract__main-collection in the
 * fetched copy, #shopify-section-template--...__main on the page), so pouring
 * the fetched markup into the page's element would leave every rule pointing
 * at an id that is not there.
 *
 * RECORDING THE VEHICLE. ao-garage.js and ao-garage-endpoint.js already catch
 * the click at the document (the tiles carry the menu's data attributes), so
 * this file only adds AOGarage.state(): answering "What do you drive?" is a
 * statement and should outrank later browsing. preventDefault() below does
 * not stop those listeners - it cancels navigation, not propagation.
 *
 * Any failure falls back to following the link, which lands on the
 * generation's own collection page. Nothing here may leave a customer stuck.
 */
(function () {
  if (window.AOVehiclePicker) return;
  window.AOVehiclePicker = true;

  var GRID_SECTION = 'abstract__main-collection';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function grid() {
    return document.querySelector('.shopify-section--main-collection');
  }

  function withParam(url, param) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + param;
  }

  function init(root) {
    var steps = root.querySelectorAll('[data-ao-vp-step]');
    var modelsStep = root.querySelector('[data-ao-vp-step="models"]');
    var savedStep = root.querySelector('[data-ao-vp-step="saved"]');
    var title = root.querySelector('[data-ao-vp-results-title]');
    var vehicleChip = root.querySelector('[data-ao-vp-clear-vehicle]');
    var catChip = root.querySelector('[data-ao-vp-clear-cat]');
    var results = root.querySelector('[data-ao-vp-results]');
    var allTitle = title ? title.textContent : '';

    var originalGrid = null;
    var current = null;
    var request = 0;

    /* Single-vehicle page (/collections/cybertruck): the vehicle is the page,
       so it is "picked" from the start. Only the category tiles do anything,
       and there is no vehicle filter to remove. */
    var single = root.hasAttribute('data-ao-vp-single');
    if (single) {
      current = {
        url: root.getAttribute('data-ao-vp-single-url'),
        name: root.getAttribute('data-ao-vp-single-name'),
        years: '',
        block: root.getAttribute('data-ao-vp-single-block'),
      };
    }

    /* Render the generation's grid through THIS page's template (`view`) and
       ask for THIS page's grid section by id. The result is the same section
       with the same settings - no filter sidebar appearing, same page size -
       just fed a different collection. Without a template suffix (a page using
       the default template) fall back to the section file name, which renders
       with schema defaults. */
    var view = root.getAttribute('data-ao-vp-view');
    var startGrid = grid();
    var sectionId = startGrid && startGrid.id ? startGrid.id.replace(/^shopify-section-/, '') : '';
    var gridQuery = view && sectionId
      ? 'view=' + encodeURIComponent(view) + '&section_id=' + encodeURIComponent(sectionId)
      : 'section_id=' + GRID_SECTION;

    function show(step, focus) {
      each(steps, function (s) {
        s.hidden = s !== step;
      });
      if (focus) {
        var heading = step.querySelector('.ao-vp__h2');
        if (heading) heading.focus({ preventScroll: false });
      }
    }

    function catLists() {
      return root.querySelectorAll('[data-ao-vp-cats]');
    }

    function swapGrid(url) {
      var el = grid();
      if (!el) {
        window.location.href = url;
        return;
      }
      if (!originalGrid) originalGrid = el.cloneNode(true);

      var mine = ++request;
      el.setAttribute('aria-busy', 'true');

      fetch(withParam(url, gridQuery), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('grid ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (mine !== request) return; // a later click won
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.shopify-section');
          if (!fresh) throw new Error('grid: no section in response');
          /* Pagination and sort links in the fetched grid inherit `view=`. Left
             in, "page 2" would open the generation's collection dressed in THIS
             brand template. Without it they go to the generation's own page,
             which is where a customer paging through one car's parts belongs. */
          Array.prototype.forEach.call(fresh.querySelectorAll('a[href*="view="]'), function (a) {
            a.setAttribute('href', a.getAttribute('href').replace(/([?&])view=[^&]*&?/, '$1').replace(/[?&]$/, ''));
          });
          var now = grid();
          if (now) now.replaceWith(fresh);
        })
        .catch(function () {
          if (mine !== request) return;
          window.location.href = url;
        });
    }

    function restoreGrid() {
      request++;
      var el = grid();
      if (el && originalGrid) el.replaceWith(originalGrid.cloneNode(true));
    }

    function paintResults(catLabel) {
      if (!title) return;
      if (!current) {
        title.textContent = allTitle;
        vehicleChip.hidden = true;
        catChip.hidden = true;
        return;
      }
      title.textContent = catLabel
        ? catLabel + ' for your ' + current.name
        : single ? allTitle : 'Everything for your ' + current.name;
      vehicleChip.querySelector('[data-ao-vp-chip-vehicle]').textContent = current.name;
      vehicleChip.hidden = single;
      catChip.querySelector('[data-ao-vp-chip-cat]').textContent = catLabel || '';
      catChip.hidden = !catLabel;
    }

    function paintBar(tile) {
      savedStep.querySelector('[data-ao-vp-saved-name]').textContent = current.name;
      savedStep.querySelector('[data-ao-vp-saved-years]').textContent = current.years ? '· ' + current.years : '';
      savedStep.querySelector('[data-ao-vp-saved-short]').textContent = current.name;
      savedStep.querySelector('[data-ao-vp-saved-link]').setAttribute('href', current.url);

      var media = savedStep.querySelector('[data-ao-vp-saved-media]');
      var src = tile.getAttribute('data-gen-image');
      media.classList.toggle('ao-vp__bar-media--photo', tile.hasAttribute('data-gen-photo'));
      if (src) {
        media.innerHTML = '';
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        media.appendChild(img);
      }

      var note = savedStep.querySelector('[data-ao-vp-saved-note]');
      if (note) note.textContent = note.getAttribute(window.customer ? 'data-signed-in' : 'data-signed-out');
    }

    function showCats(blockId) {
      var shown = null;
      each(catLists(), function (list) {
        var mine = list.getAttribute('data-ao-vp-cats') === blockId;
        list.hidden = !mine;
        if (mine) shown = list;
      });
      if (!shown) return;
      // Real hrefs, so a middle-click or a crawler still gets somewhere sensible.
      each(shown.querySelectorAll('[data-ao-vp-cat]'), function (link) {
        var query = link.getAttribute('data-ao-vp-cat');
        link.setAttribute('href', query ? withParam(current.url, query) : current.url);
        link.setAttribute('aria-current', query ? 'false' : 'true');
      });
    }

    function select(tile, opts) {
      current = {
        url: tile.getAttribute('href'),
        name: tile.getAttribute('data-gen-name'),
        years: tile.getAttribute('data-gen-years'),
        block: tile.getAttribute('data-ao-vp-block'),
      };

      if (opts.state && window.AOGarage) {
        var scope = tile.closest('[data-vehicle-handle]');
        if (scope) {
          window.AOGarage.state(
            scope.getAttribute('data-vehicle-label'),
            scope.getAttribute('data-vehicle-handle'),
            tile.getAttribute('data-generation-handle'),
            tile.getAttribute('data-generation-label')
          );
        }
      }

      paintBar(tile);
      show(savedStep, opts.focus);
      showCats(current.block);
      paintResults(null);
      swapGrid(current.url);
    }

    function pickCat(link) {
      if (!current) return;
      var query = link.getAttribute('data-ao-vp-cat');
      var list = link.closest('[data-ao-vp-cats]');
      each(list.querySelectorAll('[data-ao-vp-cat]'), function (other) {
        other.setAttribute('aria-current', other === link ? 'true' : 'false');
      });
      paintResults(query ? link.getAttribute('data-ao-vp-cat-label') : null);
      swapGrid(query ? withParam(current.url, query) : current.url);
      if (results && results.getBoundingClientRect().top < 0) results.scrollIntoView({ behavior: 'smooth' });
    }

    function clearVehicle() {
      current = null;
      each(catLists(), function (list) {
        list.hidden = true;
      });
      paintResults(null);
      restoreGrid();
      show(modelsStep, true);
    }

    root.addEventListener('click', function (event) {
      var target = event.target;

      var model = target.closest('[data-ao-vp-model]');
      if (model) {
        var panel = document.getElementById('ao-vp-gens-' + model.getAttribute('data-ao-vp-model'));
        if (panel) show(panel, true);
        return;
      }

      if (target.closest('[data-ao-vp-back]') || target.closest('[data-ao-vp-change]')) {
        show(modelsStep, true);
        return;
      }

      // Let new-tab and new-window clicks behave as normal links.
      var plain = !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0);

      var pick = target.closest('[data-ao-vp-pick]');
      if (pick && plain) {
        event.preventDefault();
        select(pick, { state: true, focus: true });
        return;
      }

      var cat = target.closest('[data-ao-vp-cat]');
      if (cat && plain) {
        event.preventDefault();
        pickCat(cat);
        return;
      }

      if (target.closest('[data-ao-vp-clear-vehicle]')) {
        clearVehicle();
        return;
      }

      if (target.closest('[data-ao-vp-clear-cat]') && current) {
        var all = root.querySelector('[data-ao-vp-cats="' + current.block + '"] [data-ao-vp-cat=""]');
        if (all) pickCat(all);
      }
    });

    /* A returning visitor: the garage already knows the car. Open on the bar
       rather than asking again. Only what the garage can answer exactly is
       restored - a generation, or a vehicle that has just one. A model alone
       (someone clicked "Model Y" in the menu) opens that model's step 2. */
    if (single) return;
    var rec = window.AOGarage ? window.AOGarage.get() : null;
    if (!rec || !rec.modelHandle) return;

    var tile = null;
    if (rec.genHandle) {
      each(root.querySelectorAll('[data-ao-vp-pick]'), function (t) {
        if (!tile && t.getAttribute('data-generation-handle') === rec.genHandle) tile = t;
      });
    }
    if (tile) {
      select(tile, { state: false, focus: false });
      return;
    }

    /* 🔴 Only when exactly ONE vehicle uses that hub. Rivian's R1T, R1S and R2
       all share the "rivian" hub, so a bare "Rivian" click in the menu says
       nothing about which - matching on the hub alone would have opened every
       Rivian visitor on the R2. */
    var scopes = [];
    each(root.querySelectorAll('[data-vehicle-handle]'), function (s) {
      if (s.getAttribute('data-vehicle-handle') === rec.modelHandle) scopes.push(s);
    });
    if (scopes.length !== 1) return;

    var only = scopes[0];
    if (only.matches('[data-ao-vp-step="gens"]')) {
      show(only, false);
    } else {
      var single = only.querySelector('[data-ao-vp-pick]');
      if (single) select(single, { state: false, focus: false });
    }
  }

  function start() {
    each(document.querySelectorAll('[data-ao-vp]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
